import React from 'react'

import './Footer.css'

function Footer() {
  return (
    <div className="footer-wrapper">
      <h3>
        Made with ♥ by <a className="footer-link" href="https://twitter.com/christo_kade">Christopher Kade</a>
      </h3>
    </div>
  )
}

export default Footer
